<template>
    <div class="ur-system">
        <!--
            $ver: v0.1.0
            <em>ur-system</em>은 기본적으로 주어진 컨텐츠를 그대로 랜더링합니다.
            #<em>ur-system</em> renders content as it is by default.
        -->
        <slot></slot>
        <ur-toast/>
        <ur-global-snackbar/>
    </div>
</template>

<script>
    import urGlobalSnackbar from "../../element/urSnackbar/urGlobalSnackbar";
// ur-system은 Vue Instance의 root element역할을 하며 .ur-system이라는 class name을
// 전역에 부여하여 css override를 돕고 특정 component(ur-tooltip 등)의 위치를 지정할 때 boundary 역할을 하기도 합니다.
// #The ur-system acts as the root element of the Vue Instance, giving it a global class name of .ur-system to aid css overrides,
// #and also acts as a boundary when locating specific components (such as ur-tooltips).
export default {
    name: 'UrSystem',
    //global snackbar는 전역적으로 사용불가하끔
    components: {urGlobalSnackbar}
}
</script>
